<template>
  <div>
    <el-row type="flex" class="row-bg">
      <el-col :span="4" :xs="24">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="paramsObj.keyword" placeholder="支持款式搜索" @keyup.enter="fetch"
            style="max-width: 120px;"></el-input>
        </el-form-item>
      </el-col>

      <el-col v-if="showOrgFilters" :span="5" :xs="24">
        <el-tree-select ref="companys" v-model="paramsObj.companyId" :data="companys" @change="fetch"
          check-strictly :render-after-expand="false" placeholder="请选择公司" style="width:250px" />
      </el-col>

      <el-col v-if="showOrgFilters" :span="3" :xs="24">
        <el-select v-model="paramsObj.storeCode" placeholder="请选择库房" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in store" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-col v-if="showOrgFilters" :span="3" :xs="24">
        <el-select v-model="paramsObj.channel" placeholder="渠道" size="default" @change="fetch" clearable
          style="max-width: 120px;">
          <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-col>

      <el-col :span="5" :xs="24">
        <el-date-picker v-model="valueTime" type="daterange" @calendar-change="fetch" change="fetch"
          unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD"
          :shortcuts="$util.getShortCuts()" size="default" style="max-width: 210px;">
        </el-date-picker>
      </el-col>

      <el-col :xs="24" :sm="12" :md="2" :lg="2" :xl="2">
        <el-button style="margin: 0 10px" size="default" type="primary" @click="fetch"> 确认 </el-button>
      </el-col>
    </el-row>

    <el-row type="flex" :gutter="20">
      <el-col :span="24" :xs="24">
        <h4 style="margin:10px auto; text-align: left;">周期内渠道的退货率汇总情况</h4>
        <el-table class="table" :data="returnChannelData" border size="small" style="margin:0 auto">
          <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
          <el-table-column prop="渠道名称" label="渠道名称" width="130" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="销售数量" label="销售数量" width="120" sortable align="center"> </el-table-column>
          <el-table-column prop="退货数量" label="退货数量" width="120" sortable align="center"> </el-table-column>
          <el-table-column prop="退货率" label="退货率(%)" width="100" sortable align="center"> </el-table-column>
        </el-table>

        <h4 style="margin:10px auto; text-align: left;">周期内渠道的款式退货率汇总Top100</h4>
        <el-table class="table" :data="returnProductData" border size="small">
          <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
          <el-table-column prop="系统款号" label="系统款号" width="130" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="图片" label="图片" width="90" sortable show-overflow-tooltip>
            <template #default="dataObj">
              <el-image style="height: 32px; width: 32px" lazy
                :src="apiUrl + 'static/code/' + dataObj.row.系统款号 + '?t=0'"
                :preview-src-list="[apiUrl + 'static/code/' + dataObj.row.系统款号 + '?t=1']">
                <template #error>
                  <img style="width: 100%" src="~@/assets/imgunfine.jpg"
                    :data-src="'static/code/' + dataObj.row.系统款号 + '?t=1'" alt="" />
                </template>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="款式名称" label="款式名称" width="180" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="大类" label="大类" width="100" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="自定款号" label="自定款号" width="120" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="规格" label="规格" width="80" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="主材质" label="主材质" width="80" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="克重" label="克重" width="80" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="品牌款号" label="品牌款号" width="120" sortable show-overflow-tooltip> </el-table-column>
          <el-table-column prop="工厂款号" label="工厂款号" width="120" sortable show-overflow-tooltip> </el-table-column>

          <el-table-column prop="销售数量" label="销售数量" width="100" sortable align="center"> </el-table-column>
          <el-table-column prop="退货数量" label="退货数量" width="100" sortable align="center"> </el-table-column>
          <el-table-column prop="退货率" label="退货率(%)" width="100" sortable align="center"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ReturnData',
  data() {
    return {
      apiUrl: process.env.VUE_APP_BASEURL,
      valueTime: [],
      paramsObj: {
        keyword: '',
        companyId: '',
        storeCode: '',
        channel: '',
        startDate: '',
        endDate: ''
      },
      companys: [],
      store: [],
      channels: [],
      returnChannelData: [],
      returnProductData: []
    }
  },
  methods: {
    getDefaultCompanyId() {
      if (!this.showOrgFilters) return '*';
      const fromStore = (this.$store.getters.getUserInfo || {}).companyID;
      if (fromStore) return fromStore;
      try {
        const raw = sessionStorage.getItem('userInfo');
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed.companyID || '';
      } catch (e) {
        return '';
      }
    },
    fetch() {
      if (!this.showOrgFilters) {
        this.paramsObj.companyId = '*';
      } else {
        if (!this.companys.length) this.$kaung.companys().then(res => { this.companys = res; });
        if (!this.paramsObj.companyId) this.paramsObj.companyId = this.getDefaultCompanyId();
      }
      if (!this.paramsObj.companyId) {
        this.$message.warning('请选择公司');
        return;
      }
      if ((!this.valueTime || this.valueTime.length != 2) && (!this.paramsObj.startDate || !this.paramsObj.endDate)) {
        this.$message.warning('请选择时间范围');
        return;
      }
      if (this.valueTime && this.valueTime.length === 2) {
        this.paramsObj.startDate = this.formatTime(this.valueTime[0]);
        this.paramsObj.endDate = this.formatTime(this.valueTime[1]) + ' 23:59:59';
      }

      request({
        url: '/StockStore/ReturnReport',
        method: 'get',
        params: this.paramsObj
      }).then((res) => {
        this.returnChannelData = res.data.channelData;
        this.returnProductData = res.data.productData;
      });
    },
    formatTime(val) { return val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate(); }
  },
  mounted() {
    this.$kaung.dictionary('stock', 'store').then(res => this.store = res);
    this.$kaung.dictionary('stock', 'channel').then(res => this.channels = res);
    // 初始化默认时间范围（设置 paramsObj，不更改 date-picker v-model）并自动加载数据
    const range = this.$util.getCurrentDate('month');
    if (range && range.length === 2) {
      this.valueTime = range;
      this.paramsObj.startDate = this.formatTime(range[0]);
      this.paramsObj.endDate = this.formatTime(range[1]) + ' 23:59:59';
    }
  }
}
</script>

<style scoped>
.row-bg { margin-bottom: 10px; }
</style>

<style lang="less" scoped>
.console-page {
  .el-row {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-card {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h4 {
    margin-top: 5px;

    .number {
      color: #409eff;
    }
  }

  .tableshow {
    img {
      transform: scale(1.3, 1.3);
    }
  }

  .showtext {
    line-height: 20px;
    margin-left: 10px;
  }

  .row-bg {
    .el-col {
      padding: 2px 0;
    }

    padding: 10px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-date-editor {
    width: 100%;
    max-width: 280px;
  }

  .text-gray {
    font-family: "PingFang SC";
  }

  .el-table th>.cell {
    padding: 0;
    color: #000;
  }

  .el-table .caret-wrapper {
    width: 12px;
    left: -5px;
  }
}

.panel-group .card-panel:hover {
  background: #a9a9a9;
}

.panel-group .card-panel {
  height: 70px !important;
}

.panel-group .card-panel .card-panel-icon-wrapper {
  margin: 10px 0 0 10px !important;
}

.card-panel .card-panel-description {
  margin-top: 10px !important;
}

@media (max-width: 550px) {
  .card-panel-icon-wrapper {
    width: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
